import { connect } from "scrivito"
import { BuildingReferenceObj } from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"

import { BuildingReferencePageView } from "./BuildingReferencePageView"
import { useBuildingReferencePageViewModel } from "./hooks/useBuildingReferencePageViewModel"

export interface BuildingReferencePageProps {
  page: BuildingReferenceObj
}

export function BuildingReferencePageComponent(
  props: BuildingReferencePageProps
) {
  const { page } = props
  return (
    <BuildingReferencePageView
      key={page.id()}
      {...useBuildingReferencePageViewModel(props)}
    />
  )
}

export const BuildingReferencePage = connect(BuildingReferencePageComponent)
